import { Box, Tabs, Tab, Container, Typography, Collapse, Grow, Skeleton } from "@mui/material";
import { Header } from "../Header";
import React, { useEffect, useState } from "react";
import PersonIcon from '@mui/icons-material/Person';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Profile } from "./profile";
import { Subscription } from "./subscription";
import { Order } from "./order";
import { Error } from "../Error";
import { Loading } from "../Loading";

interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  id: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, id, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden= {id != value}
      id={`vertical-tabpanel-${id}`}
      sx={{width: "100%", minHeight: "306px",padding: 3}}
    >
      <Box>
        {children}
      </Box>
    </Box>
  );
}

export const Account = () => {
  const [value, setValue] = useState("perfil");
  const [loading, setLoading] = useState({ state: false, message: "" });
  const [error, setError] = useState({ state: false, title: "", message: "" });
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const showLoading = (msg: string) => setLoading({ ...loading, state: true, message: msg });
  const hideLoading = () => setLoading({ ...loading, state: false, message: "" });
  const showError = (title: string, message: string) => setError({ state: true, title, message });
  const hideErrorModal = () => setError({ ...error, state: false, title: "", message: "" });
  
  return (
    <>
      <Header />
      <Container style={{ maxWidth: "1800px", paddingInline: "6%" }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', marginBlock: 5 , fontWeight: "500", fontSize: "20px", color: "var(--text-primary)" }}
        >
          <h2>Minha Conta</h2>
        </Box>
        <Box
          sx={{flexGrow: 1, minWidth: 850, bgcolor: 'background.paper', display: 'flex', marginBlock: 5, borderRadius: "4px", boxShadow: 1, paddingBlock: 1 }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            orientation="vertical"
            sx={{ borderRight: 1, borderColor: 'divider' , minWidth: "160px"}}
          >
            
            <Tab value="perfil" label="Perfil" icon={<PersonIcon />} iconPosition="start" sx={{justifyContent: "left", boxShadow: "0px 12px 5px -15px black"}} />
            <Tab value="assinatura" label="Assinatura" icon={<CardMembershipIcon />} iconPosition="start" sx={{justifyContent: "left", boxShadow: "0px 12px 5px -15px black"}} />
            <Tab value="compras" label="Compras" icon={<ShoppingCartIcon />} iconPosition="start" sx={{justifyContent: "left", boxShadow: "0px 12px 5px -15px black"}} />
                
          </Tabs>
          <TabPanel value={value} id="perfil" >
            <Profile
              showLoading={showLoading}
              hideLoading={hideLoading}
              showError={showError}
            />
          </TabPanel>
          <TabPanel value={value} id="assinatura" >
            <Subscription
              showLoading={showLoading}
              hideLoading={hideLoading}
              showError={showError}
            />
          </TabPanel>
          <TabPanel value={value} id="compras" >
            <Order
              showLoading={showLoading}
              hideLoading={hideLoading}
              showError={showError}
            />
          </TabPanel>
       </Box>
      </Container>
      <Loading
        mode="blurry"
        hidden={!loading.state}
        messages={loading.message}
      />
      <Error
        hasOpen={error.state}
        handleClose={hideErrorModal}
        errorMsg={error.message}
        title={error.title}
      />
    </>
  );
};
